export default __webpack_public_path__ + "static/media/landing-page2.7c3fc5f0.jpeg";